module.exports = __webpack_public_path__ + "img/imagen4.aca18bc5.png";